
// DB chính
//  export const localhost = 'http://192.168.1.80:8000';

// DB local test    
//  export const localhost = 'http://10.2.21.209:8000';
//  export const localhost = 'http://10.2.21.90:8000';


//  export const localhost = 'http://192.168.20.161:8000';
export const localhost = 'https://qldt.rainscales.com.vn';